import {
  BstlArtikel,
  BPArtikelAnzahlRequest,
  BPArtikelHinzufuegenRequest,
  RemoteResult,
  IdRequest,
  ReservierungNeu,
  PreislisteZeitraumRequest,
  PlisteProduktZeit,
  LoadState,
} from "mangdto"
import ProdukteLogic from "@/logic/produkte_logic"
import router from "@/router"
import { ConverterUtil } from "mangutil"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"

export default class ReservierungVorbestellungLogic extends ProdukteLogic {
  bestellungCompleted: boolean = false
  reservierung: ReservierungNeu = null
  insertBestellungLoadState: LoadState = LoadState.Loading
  reservierungId: string = null
  private _warenkorb: BstlArtikel[] = []


  get warenkorb(): BstlArtikel[] {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  loadPreislisten() {
    this.listeLoadState = LoadState.Loading

    var request = new PreislisteZeitraumRequest()
    request.zeitpunkt = this.reservierung.zeitVon

    request.filialeId = this.filiale.filialeId

    if (this.mainLogic.reservierung.vorbestellungPending) {
      this._warenkorb =
        this.mainLogic.reservierung.vorbestellungPending.artikelliste
    }

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.listeLoadState = LoadState.Completed

          this.preisliste = response.data.payload
        } else {
          this.listeLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.listeLoadState = LoadState.Error
      })
  }

  init() {
    this.reservierung = this.mainLogic.reservierung
    if (this.reservierung != null) this.loadPreislisten()

    this.mainLogic.reservierungListeners.push(() => {
      this.reservierung = this.mainLogic.reservierung
      if (this.reservierung != null) this.loadPreislisten()
    })
  }

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.RESERVIERUNG.VORBESTELLUNG_BESTAETIGEN,
    })
  }

  addArtikel(artikel: BstlArtikel): void {
    this.insertArtikelLoadState = LoadState.Loading

    var request = new BPArtikelHinzufuegenRequest()
    request.id = this.reservierung.id //this.reservierungId
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)

    Poster.postUser<RemoteResult<BstlArtikel>>(
      RestPaths.reservierungenVorbestellungPendingArtikelHinzufuegen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.insertArtikelLoadState = LoadState.Completed
          this.warenkorb.push(artikel)
          this.artikel = null
          this.artikelDialogVisible = false
        } else {
          this.insertArtikelLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.insertArtikelLoadState = LoadState.Error
      })
  }

  geheZurBestellung() {
    router.push({
      name: RouteNames.RESERVIERUNG_DETAILS,
      params: { reservierungId: this.reservierungId },
    })
  }

  bestellungBestaetigen() {
    this.insertBestellungLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = this.reservierungId

    Poster.postUser<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingBestaetigen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.insertBestellungLoadState = LoadState.Completed

          this.bestellungCompleted = true
        } else {
          this.insertBestellungLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.insertArtikelLoadState = LoadState.Error
      })
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.vorbestellungPending.id
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request,
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = this.mainLogic.reservierung.vorbestellungPending.id
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.reservierungenVorbestellungPendingArtikelAendern,
        request,
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.reservierung.vorbestellungPending.id
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postMember<RemoteResult<any>>(
      RestPaths.reservierungenVorbestellungPendingArtikelAendern,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1,
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }
}
